import { ERequestStatus } from '../requestStatus';
import { ITextFieldState } from './textField';

export enum EPostFormFieldName {
  Title = 'title',
  FeaturedImage = 'featuredImage',
}

export type TPostFormFields = {};

export type TFieldStates = ITextFieldState;

export interface IPostForm<Fields extends TPostFormFields = {}> {
  fields: Fields;
  formMessage: string;
  formStatus: ERequestStatus;
}
